import React, { Fragment } from 'react'
import { func } from 'prop-types'
import Cookies from 'js-cookie'
import {
  Modal, Icon, AttentionFilled, Button,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

function AdultContentModal({ setViewerIsAdult, hideAdultModal }) {
  function handleSubmit() {
    if (Cookies) {
      Cookies.set('i_am_an_adult', true, { expires: 365 })
      window.pageConfig.viewerIsAdult = true
      setViewerIsAdult(true)
      hideAdultModal()
    }
  }

  function renderFooter() {
    return (
      <Fragment>
        <Button
          type="secondary"
          onClick={hideAdultModal}
          customClass="adult-content-modal__cancel-button"
        >
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={handleSubmit}
          customClass="adult-content-modal__accept-button"
        >
          I am over 18
        </Button>
      </Fragment>
    )
  }

  function renderHeaderIcon() {
    return (
      <div className="adult-content-modal__icon-wrapper">
        <Icon
          svgComponent={AttentionFilled}
          color="light"
        />
      </div>
    )
  }

  return (
    <Modal
      width="small"
      size="small"
      header="AGE-RESTRICTED CONTENT"
      headerIcon={renderHeaderIcon()}
      onClose={hideAdultModal}
      canClose={false}
      footer={renderFooter()}
      customClass="adult-content-modal"
    >
      The model you want to see contains adult content marked as age-restricted.
      You must be at least 18 years old to view it. Are you over 18 and willing to see adult content?
    </Modal>
  )
}

AdultContentModal.propTypes = {
  setViewerIsAdult: func.isRequired,
  hideAdultModal: func.isRequired,
}

export default AdultContentModal
